//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { staticType } from "./config"
import Xcell from '@/components/common/x-cell'
import bridgeApi from "sy-bridge";

export default {
    name:'instructionProtocol',
    data(){
        return {
            selectFlag:false,
            modeShow:false,
            modeTitle:'',
            modeList:[]
          }
    },
    props: {
        type:{
           type: String,
            default() { return 'green' } 
        },
        staticName:{ //埋点配置信息
            type: String,
            default() { return 'proinfo' } 
        },
        materielMap:{ //协议内容
            type: Array,
            default() { return  [] } 
        },
        defaultChecked:{ // 默认选中
            type: Boolean,
            default:false,
        },
        size11:{ //字号为11
            type: Boolean,
            default:false,
        }
    },
    components:{
        Xcell
    },
    methods:{
        // 判断是否勾选
        checkSelectFlag(){
            return new Promise((resolve,reject)=>{
                 this.selectFlag?resolve(true):resolve(false)
            })
        },
        // 协议勾选框点击
        selectClick(){
            this.selectFlag = !this.selectFlag
            this.$emit('input', this.selectFlag)

        },
        // 展示弹框
        treatyClick(item){
            this.$emit('treatyClick');
            if(item.materielList.length > 1){
                this.modeShow = true;
                this.modeTitle = item.fileCategoryDesc
                this.modeList = item.materielList
            }else{
                this.cellClick(item.materielList[0])
            }  
        },
        cellClick(item){
            console.log('item',item)
            
            if(item.shortUrl){
                const url = `${encodeURIComponent(
                    item.shortUrl
                )}`;
                this.$router.push({
                    path: "/webpdf",
                    query: {
                        file: url
                    },
                    flag: "postdisable",
                });
            }else{
               this.$toast("未获取到pdf地址");
            }
            
        }
    }
}
